export default __webpack_public_path__ + "static/media/franchise-training-main.3120f603.jpg";